import styled from "styled-components";

const Container = styled.nav`
  height: 100px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: white;
  width: 90%;
  margin: 0px auto;
  @media (max-width: 1200px) {
    margin: 0;
    padding: 0;
    height: 80px;
    width: 100%;
  }
  @media (max-width: 768px) {
    margin: 0;
    padding: 0;
    height: 60px;
  }
`;

const Logo = styled.img`
  height: 40px;
  margin: 30px 20px;
  @media (max-width: 1200px) {
    height: 35px;
    margin: 22.5px 20px;
  }
  @media (max-width: 768px) {
    margin: 15px 20px;
    max-width: auto;
    height: 30px;
  }
`;

const MobileMenuContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: #AB8356;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  overflow: scroll;
  max-width: 440px;
  box-shadow: -10px 3px 6px rgba(0,0,0,0.16);
  display: none;
  @media (max-width: 1200px) {
    display: block;
  }
`

const MobileMenu = styled.div`
  display: none;
  @media (max-width: 1200px) {
    display: flex;
    flexDirection: column;
    align-items: center;
    justify-content: center;
    width: 75px;
    heigth: 100%;
    background-color: #AB8356;
    cursor: pointer;
  }
`;

const WebViewMenu = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 100%;
  @media (max-width: 1200px) {
    display: none;
  }
`;

const Ul = styled.ul`
  display: flex;
  flex-direction: ${props => props.mobile ? 'column' : 'row'};
  justify-content: flex-end;
  align-items: ${props => props.mobile ? 'flex-end' : 'center'};
  margin: 0;
  padding: 0;
  margin-right: 0px;
  @media (max-width: 1200px) {
    margin-right: 20px;
    margin-top: ${props => props.mobile ? '15vh' : null};
    line-height: ${props => props.mobile ? '40px' : null};
  }
`;

const Li = styled.li`
  margin-left: 2rem;
  list-style: none;
  font-size: 16px;
  @media (max-width: 1200px) {
    margin-left: 1.5em;
    font-size: 14px;
  }
`;

const MainButton = styled.button`
  background-color: #B6936C;
  min-height: 100%;
  border: 0;
  color: white;
  font-weight: 400;
  margin: 0 20px;
  padding: 0 30px;
  @media (max-width: 1200px) {
    display: none;
  }
`;

const Cart = styled.img`
  height: 30px;
  /* margin: 30px 10px; */
  @media (max-width: 1200px) {
    display: none;
  }
`;

export {
  Container,
  Logo,
  WebViewMenu,
  Ul,
  Li,
  MainButton,
  Cart,
  MobileMenu,
  MobileMenuContainer
};